import { Col, ColProps } from 'antd';
import styled from 'styled-components';

export const LeftMenu = styled(Col).attrs<ColProps>({ xxl: 4, xl: 5, lg: 5 })`
  background: var(--page-background);
  height: 100vh;
  padding: var(--spacing-05);
  display: flex;
  flex-direction: column;

  h5 {
    margin-bottom: var(--spacing-05);
  }
`;
